import { render, staticRenderFns } from "./PurchaseReportFiling.vue?vue&type=template&id=075e95a6&scoped=true&"
import script from "./PurchaseReportFiling.vue?vue&type=script&lang=js&"
export * from "./PurchaseReportFiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e95a6",
  null
  
)

export default component.exports